(function (cw, $, undefined) {
  $.extend(true, cw, {
    appEnum: {
      alertLevel: {
        unknown: 0,
        success: 1,
        info: 2,
        warning: 3,
        danger: 4,
      },
      Status: {
        Unknown: 0,
        Active: 1,
        Disabled: 2,
        Deleted: 3,
      },
      TemplateType: {
        Unknown: 0,
        Master: 1,
        Page: 2,
        Widget: 3,
        Email: 4,
        Invoice: 5,
        Dashboard: 6,
        CwWidget: 7,
      },
      FileExtensionType: {
        Unknown: 0,
        PNG: 1,
        JPG: 2,
        GIF: 3,
        PDF: 4,
        DOCX: 5,
        DOC: 6,
        XLSX: 7,
        XLS: 8,
        BMP: 9,
        TIFF: 10,
        MP4: 11,
        MPEG: 12,
        AVI: 13,
        MP3: 14,
        ZIP: 15,
        PPTX: 16,
        PPT: 17,
        WAV: 18,
        YouTube: 19,
        HTML: 20,
        ExtUrlLink: 21,
      },
      ImageAssetType: {
        ProfileImage: 1,
        HRResource: 2,
        PostAsset: 3,
        InvoiceAd: 4,
        UtilityBillSampleImage: 5,
        TosDocument: 6,
      },
      GraphSeriesType: {
        lines: 1,
        points: 2,
        bars: 4,
        pie: 5,
        zippolyheatmap: 6,
        donut: 1006,
        gauge: 1007,
      },
      CreditApprovalAction: {
        Unknown: 0,
        Approved: 1,
        AutomaticPaymentRequired: 2,
        RequiresReview: 3,
        Denied: 4,
        DeniedPendingFCRALetter: 5,
        DeniedFCRALetterPrinted: 6,
        Deleted: 7,
      },
      PricingTypeCode: {
        VariablePrice: 1,
        PreBuy: 2,
        Cap: 3,
        FixedPrice: 4,
        FirstFill: 5,
        WillCallCashPrice: 6,
        Subscription: 7,
      },
      ProductCode: {
        HeatingOil: 2,
        NaturalGas: 60,
        Propane: 70,
        Electricity: 80,
        ServiceProduct: 200,
        ScheduleService: 399,
      },
      PriceDisplayType: {
        DollarsPerUnit: 1,
        CentsPerUnit: 2,
      },
      CustomerClass: {
        Residential: 1,
        SmallBusiness: 2,
        Commercial: 3,
        Wholesale: 4,
      },
      S1RemoteSystem: {
        As400: 1,
        Nexant: 2,
        CreditApplication: 3,
        Cargas: 4,
      },
      PaymentProcessType: {
        AutomaticCreditCard: 1,
        CustomerWillInitiatePayment: 2,
        AutomaticBankDraft: 3,
        COD: 4,
      },
      DeliverySchedule: {
        WillCall: "W",
        Automatic: "A",
        Scheduled: "S",
      },
      //////// Seems to match an old table that is now obsolete --> TJN 8/27/2018
      ////////tblUnitOfMeasureType
      ////////UnitOfMeasure: {
      ////////	Unknown: 0,
      ////////	Therm: 1,
      ////////	MCF: 2,
      ////////	CCF: 3,
      ////////	kWh: 4,
      ////////	mWh: 5
      ////////},
      UnitOfMeasure: {
        gallon: 1,
        kWh: 2,
        Therm: 3,
        CCF: 4,
        month: 5,
        MCF: 6,
        mWh: 7,
        DTH: 8,
      },
      TicketStatus: {
        Unassigned: 1,
        Assigned: 2,
        Inprogress: 3,
        Completed: 4,
        Canceled: 5,
        OnHold: 6,
        WaitingCustomerResponse: 7,
      },
      CreditStatus: {
        Unknown: 0,
        Ok: 1,
        CreditHold: 2,
        BudgetHold: 3,
      },
      PasswordValidation: {
        Unauthorized: 0,
        Blank: 1,
        PasswordIsNameOrLogin: 2,
        ComplexityFailure: 3,
        NewOldPasswordMismatch: 4,
        NewPasswordsMismatch: 5,
        Success: 6,
      },
      PaymentMethod: {
        Eft: 1,
        CreditCard: 6,
      },
      UpdateS1EmailResponse: {
        Unauthorized: 0,
        FailedUpdate: 1,
        Success: 2,
      },
      DeleteEFTProfileResponse: {
        Unknown: 1,
        Success: 2,
        DeleteEFTFailed: 3,
        AutoPayRequiredStatusSet: 4,
        OpenOrderUsingProfile: 5,
        DeleteS1EFTFailed: 6,
      },
      DeleteCreditCardResponse: {
        Unknown: 0,
        Success: 1,
        OpenOrderCurrentlyUsingCreditCard: 2,
        ProcessorCouldNotProcessDeletion: 3,
        ReferencedCardCouldNotBeFound: 4,
        AutoPayRequiredStatusSet: 5,
        BackendSystemCouldNotProcessDeletion: 6,
      },
      BrandType: {
        ShipleyEnergy: 1,
        Sauder: 3,
        CapitolCityOil: 4,
        KeystoneOil: 5,
        EnergyObjective: 6,
        SmartTouchEnergy: 7,
        HalyOil: 8,
        Emery: 9,
        MaugerEnergy: 10,
      },
      RewardPointSource: {
        BillingTransaction: 1,
        ManuallyAwarded: 2,
        NewRewardsUser: 3,
      },
      ESignatureProvider: {
        Unknown: 0,
        HelloSign: 1,
      },
      DocumentSigningType: {
        Unknown: 0,
        PCM: 1,
        CutomerForm: 2,
      },
    },
  });
})((window.cw = window.cw || {}), jQuery);
